module.exports = __webpack_public_path__ + "static/media/sell_help_14.e988213e.png";